import React, { useReducer } from 'react';
import firebase from "firebase/app";
import { firestoreInitialize } from '../../config/firebase/client';

import ProgramsContext from './ProgramsContext';
import ProgramsReducer from './ProgramsReducer';

const ProgramsState = (props) => {
    const initialState = {
        getProgramsCategories: {
            programsCategories: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPrograms: {
            programs: [],
            firstProgram: null,
            lastProgram: null,
            nextPrograms: null,
            programsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getProgramById: {
            program: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createProgram: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateProgram: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateProgramStatus: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        deleteProgram: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    };

    const [state, dispatch] = useReducer(ProgramsReducer, initialState);

    const getProgramsCategories = () => {
        dispatch({ type: 'GET_PROGRAMS_CATEGORIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('ProgramsCategories')
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_PROGRAMS_CATEGORIES', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
        })
        .catch((error) => dispatch({ type: 'GET_PROGRAMS_CATEGORIES_ERROR', payload: { code: 'programs-categories/error', message: error } }))
    };

    const getPrograms = (nextPage, prevPage) => {
        dispatch({ type: 'GET_PROGRAMS_LOADING' });

        let db = firestoreInitialize();

        if (nextPage) {
            let first = db.collection("Programs")
                .where("isDelete", "==", false)
                .orderBy('programId')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROGRAMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Programs")
                            .where("isDelete", "==", false)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROGRAMS_ERROR', payload: { code: 'programs/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Programs")
                .where("isDelete", "==", false)
                .orderBy('programId')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROGRAMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Programs")
                            .where("isDelete", "==", false)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROGRAMS_ERROR', payload: { code: 'programs/error', message: error } }))   
        } else {
            let first = db.collection("Programs")
                .where("isDelete", "==", false)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_PROGRAMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Programs")
                            .where("isDelete", "==", false)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_PROGRAMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_PROGRAMS_ERROR', payload: { code: 'programs/error', message: error } }))   
        }
    };

    const getProgramById = (programId) => {
        dispatch({ type: 'GET_PROGRAM_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Programs").doc(programId);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_PROGRAM_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_PROGRAM_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_PROGRAM_BY_ID_ERROR', payload: { code: 'get-program/error', message: error } })
        });
    };

    const createProgram = (data) => {
        dispatch({ type: 'CREATE_PROGRAM_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        let storageRef = storage.ref();

        const metadata = {
            contentType: 'image/jpeg',
        };

        let uploadTask = storageRef.child(`Programs/program-picture-${data.name}-${data.category}`).put(data.image.file, metadata);

        uploadTask.on('state_changed', function() {
            }, function(error) {
                dispatch({ type: 'CREATE_PROGRAM_ERROR', payload: { code: 'create-program/avatar-error', message: error } });
            }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                db.collection('Programs').add({
                    programId: "",
                    category: data.category,
                    name: data.name,
                    imageUrl: downloadURL,
                    status: data.status,
                    description: data.description,
                    isTherePrecedence: data.isTherePrecedence,
                    isThereValidityConstraint: data.isThereValidityConstraint,
                    validityStartDate: data.isThereValidityConstraint ? firebase.firestore.Timestamp.fromDate(data.validityStartDate) : null,
                    validityEndDate: data.isThereValidityConstraint ? firebase.firestore.Timestamp.fromDate(data.validityEndDate) : null,
                    contractType: data.contractType,
                    amount: data.contractType !== "free" ? data.amount : null,
                    currency: data.currency,
                    tags: data.tags,
                    features: {
                        species: data.species,
                        breed: data.breed,
                    },
                    isDelete: false,
                    createdOn: firebase.firestore.FieldValue.serverTimestamp(),
                })
                    .then((doc) => {
                        db.collection('Programs').doc(doc.id).update({
                            programId: doc.id
                        })
                        .then(() => {
                            dispatch({ type: "CREATE_PROGRAM" });
                        })
                    })
                    .catch((error) => dispatch({ type: 'CREATE_PROGRAM_ERROR', payload: { code: 'create-program/error', message: error } }))
            });
        });
    };

    const updateProgram = async (data) => {
        dispatch({ type: 'UPDATE_PROGRAM_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        let storageRef = storage.ref();

        let imageUrl = data.image?.file ? "" : data.image;

        const metadata = {
            contentType: 'image/jpeg',
        };
        

        if (data.image?.file) {
            let uploadTask = await storageRef.child(`Programs/program-picture-${data.name}-${data.category}`).put(data.image.file, metadata);
            imageUrl = await uploadTask.ref.getDownloadURL();
        }

        db.collection('Programs').doc(data.programId).update({
            category: data.category,
            name: data.name,
            imageUrl: imageUrl,
            status: data.status,
            description: data.description,
            isTherePrecedence: data.isTherePrecedence,
            isThereValidityConstraint: data.isThereValidityConstraint,
            validityStartDate: data.isThereValidityConstraint ? firebase.firestore.Timestamp.fromDate(data.validityStartDate) : null,
            validityEndDate: data.isThereValidityConstraint ? firebase.firestore.Timestamp.fromDate(data.validityEndDate) : null,
            contractType: data.contractType,
            amount: data.contractType !== "free" ? data.amount : null,
            currency: data.currency,
            tags: data.tags,
            features: {
                species: data.species,
                breed: data.breed,
            },
            updatedOn: firebase.firestore.FieldValue.serverTimestamp(),
        })
            .then(() => {
                dispatch({ type: "UPDATE_PROGRAM" });
            })
            .catch((error) => dispatch({ type: 'UPDATE_PROGRAM_ERROR', payload: { code: 'update-program/error', message: error } }))
    };

    const updateProgramStatus = async (data) => {
        dispatch({ type: 'UPDATE_PROGRAM_STATUS_LOADING' });

        let db = firestoreInitialize();

        db.collection('Programs').doc(data.programId).update({
            status: data.status,
            updatedOn: firebase.firestore.FieldValue.serverTimestamp(),
        })
            .then(() => {
                dispatch({ type: "UPDATE_PROGRAM_STATUS" });
            })
            .catch((error) => dispatch({ type: 'UPDATE_PROGRAM_STATUS_ERROR', payload: { code: 'update-program-status/error', message: error } }))
    };

    const deleteProgram = async (data) => {
        dispatch({ type: 'DELETE_PROGRAM_LOADING' });

        let db = firestoreInitialize();

        db.collection('Programs').doc(data.programId).update({
            isDelete: true,
            deletedOn: firebase.firestore.FieldValue.serverTimestamp(),
        })
            .then(() => {
                dispatch({ type: "DELETE_PROGRAM" });
            })
            .catch((error) => dispatch({ type: 'DELETE_PROGRAM_ERROR', payload: { code: 'delete-program/error', message: error } }))
    };

    const createProgramsWithExcel = async (data) => {
        dispatch({ type: 'CREATE_PROGRAMS_WITH_EXCEL_LOADING' });

        let db = firebase.firestore();

        await data.forEach((doc) => {
            let parentId = '';

            db.collection("Programs").add({
                programId: "",
                programCategory: doc.programCategory,
                features: doc.features,
                status: "draft",
                isDelete: false,
                createdOn: firebase.firestore.FieldValue.serverTimestamp(),
            }).then((docRef) => {
                parentId = docRef.id;

                db.collection("Programs").doc(docRef.id).update({
                    programId: docRef.id,
                }).then(() => {
                    if (doc.activities.length > 0) {
                        doc.activities.forEach((programActivity) => {
                            db.collection("Programs").doc(parentId).collection("ProgramActivities").add({
                                programId: parentId,
                                programActivityId: "",
                                type: programActivity.type,
                                title: programActivity.title,
                                description: programActivity.description,
                                trigger: programActivity.trigger,
                                triggerMeasure: programActivity.triggerMeasure,
                                triggerValue: programActivity.triggerValue,
                                delayedActivityMessage: programActivity.delayedActivityMessage,
                                status: "draft",
                                isDelete: false,
                                createdOn: firebase.firestore.FieldValue.serverTimestamp(),
                            }).then((docRef) => {
                                db.collection("Programs").doc(parentId).collection("ProgramActivities").doc(docRef.id).update({
                                    programActivityId: docRef.id,
                                });
                            }); 
                        });
                    }
                });
            });
        });

        dispatch({ type: 'CREATE_PROGRAMS_WITH_EXCEL' });
    };

    const resetDeleteProgramState = () => {
        dispatch({ type: 'DELETE_PROGRAM_RESET_STATE' });
    };

    const resetUpdateProgramsStatusState = () => {
        dispatch({ type: 'UPDATE_PROGRAM_STATUS_RESET_STATE' });
    };

    const resetProgramsState = () => {
        dispatch({ type: 'PROGRAMS_RESET_STATE' });
    };

    return (
        <ProgramsContext.Provider value={{
            programsCategoriesState: state.getProgramsCategories,
            programsState: state.getPrograms,
            programByIdState: state.getProgramById,
            createProgramState: state.createProgram,
            updateProgramState: state.updateProgram,
            updateProgramStatusState: state.updateProgramStatus,
            deleteProgramState: state.deleteProgram,
            getProgramsCategories,
            getPrograms,
            getProgramById,
            createProgram,
            updateProgram,
            updateProgramStatus,
            deleteProgram,
            createProgramsWithExcel,
            resetUpdateProgramsStatusState,
            resetDeleteProgramState,
            resetProgramsState,
        }}>
            {props.children}
        </ProgramsContext.Provider>
    )
}

export default ProgramsState;
